import { useAccount } from 'wagmi'
import { useGetLoginInfo } from '@multiversx/sdk-dapp/hooks/account'

const useIsWalletConnected = ({ chain }: { chain: string }) => {
  const { isConnected } = useAccount()
  const { isLoggedIn } = useGetLoginInfo()

  return {
    isConnected: chain === 'multiversx' ? isLoggedIn : isConnected,
  }
}

export default useIsWalletConnected
